import { action, Action } from 'easy-peasy';

export interface PaymentRunsStateModel {
  isUpdatingPaymentRun: boolean;
  setState: Action<PaymentRunsStateModel, [string, any]>;
}

export const PaymentRunsState: PaymentRunsStateModel = {
  isUpdatingPaymentRun: false,
  setState: action((state, payload) => {
    const [prop, to] = payload;
    state[prop] = to;
  }),
};
